
<div
  class=""
  style="
    background-image: url('/src/assets/images/emblembg.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 45%;
  "
>
  <mat-dialog-content [formGroup]="approvalFlowStagesSuccessorForm">
    <div class="row">
      <div class="col-md-12">
        <mat-form-field appearance="outline" class="material-form w-100">
          <mat-label>Select Successor Stage</mat-label>
          <mat-select matInput formControlName="successorStage">
            <mat-option
              *ngFor="let stage of successorStages$ | async"
              [value]="stage.stageUniqueId"
            >
              {{ stage.stageName }}
            </mat-option>
          </mat-select>
          <mat-error>
            <span
              *ngIf="
                !approvalFlowStagesSuccessorForm.get('successorStage').valid &&
                approvalFlowStagesSuccessorForm.get('successorStage').touched
              "
            >
              Field is required.
            </span>
          </mat-error>
        </mat-form-field>
      </div>
     
    </div>
    <div class="row">
      <div class="col">
        <div class="d-flex justify-content-between mt-2">
          <button
            class="bg-tertiary-500 rounded-3xl px-3 py-2 text-white"
            (click)="closeModal($event)"
          >
            Cancel
          </button>
          <button
            [disabled]="approvalFlowStagesSuccessorForm?.invalid"
            class="bg-primary-500 px-3 py-2 rounded-3xl text-white"
            (click)="submitForm(approvalFlowStagesSuccessorForm.value)"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
